/** @jsx jsx */
import { createContext, useContext, useEffect, useRef, } from 'react';
import { jsx } from 'theme-ui';
import { loadIntercom } from '../util/loadIntercom';
var chatInstance = {
    open: function () {
        window.Intercom('show');
    },
    close: function () {
        window.Intercom('hide');
    },
    trackEvent: function (event, metadata) {
        window.Intercom('trackEvent', event, metadata);
    },
    identify: function (user) {
        window.Intercom('update', {
            user_id: user._id,
            email: user.email,
            name: user.name,
            user_hash: user.signature,
            company: user.organisation && {
                id: user.organisation._id,
                name: user.organisation.name,
            },
        });
    },
    showButton: function (show) {
        window.Intercom('update', { hide_default_launcher: !show });
    },
    logout: function (id) {
        window.Intercom('shutdown');
        window.Intercom('boot', { app_id: id, hide_default_launcher: false });
    },
};
var SupportChatContext = createContext(chatInstance);
export var SupportChatProvider = function (_a) {
    var id = _a.id, user = _a.user, children = _a.children;
    var shouldLogoutRef = useRef(false);
    useEffect(function () {
        if (!window.Intercom) {
            // eslint-disable-next-line no-eval
            loadIntercom(id);
        }
        window.Intercom('boot', { app_id: id });
        return function () {
            window.Intercom('shutdown');
        };
    }, [id]);
    useEffect(function () {
        if (!user) {
            if (shouldLogoutRef.current) {
                chatInstance.logout(id);
                shouldLogoutRef.current = false;
            }
        }
        else {
            chatInstance.identify(user);
            shouldLogoutRef.current = true;
        }
    }, [id, user]);
    return (jsx(SupportChatContext.Provider, { value: chatInstance }, children));
};
export function useSupportChat() {
    return useContext(SupportChatContext);
}
//# sourceMappingURL=SupportChatProvider.js.map